import axios from '@/axios.js'
import store, { initialModules } from '@/store';
import Vue from 'vue';
import router from '@/router.js'

export default {
    register({ commit, dispatch }, data) {
        axios.post('/client/register', {
            first_name:  data.firstName,
            last_name: data.lastName,
            email: data.email,
            password: data.password,
            password_confirmation: data.passwordConfirmation,
            // dob: data.dob,
        })
        .then(function (response) {
            if(response.status == 200 && response.data.success == true) 
                commit('REGISTER', response);
            dispatch('notification/notification', response, {root: true})
        })
        .catch(function (error) {
            dispatch('notification/notification', error.response, {root: true})
        });
    },
    login({ commit, dispatch }, data) {  
        axios.post('/'+data.role+'/login', {
            email: data.email,
            password: data.password
        })
        .then(function (response) {
            if(response.status == 200 && response.data.success !== false) {
                commit('LOGIN', response);
            }

            dispatch('notification/notification', response, {root: true})
        })
        .catch(function (error) {
            dispatch('notification/notification', error.response, {root: true})
        });
    },
    connectWith({ commit, dispatch }, data) {
        // data.platform values: google | facebook
        if(data.platform != 'google' && data.platform != 'facebook') {
            dispatch('notification/notification', {
                data: {
                    success: false,
                    message: 'Platforma selectata nu poate fi utilizata.'
                }
            }, {root: true}); return;
        }
        
        axios.post(`/client/connect/${data.platform}`, data.payload)
            .then(function (response) {
                if(response.status == 200 && response.data.success == true) {
                    
                    commit('LOGIN', response);
                    response.data.message = 'Conectare realizată cu succes!';
                    
                } else if(response.data.hasOwnProperty('error_code') && response.data.error_code == 'email_missing') {
                    router.push({
                        path: '/client/facebook/complete-email',
                        query: {
                            fbId: data.payload.id,
                            name: data.payload.name
                        }
                    });
                }
                dispatch('notification/notification', response, {root: true})
            })
            .catch(function (error) {
                dispatch('notification/notification', error.response, {root: true})
            });
    },
    
    loginMeeting({ commit, dispatch }, data) {
        commit('LOGIN_MEETING', data);
    },
    loginAnytimeMeeting({ commit, dispatch }, data) {
        commit('LOGIN_ANYTIME_MEETING', data);
    },
    logout({ commit, dispatch, rootState }) {
        /*
        console.log(rootState);
        console.log(initialModules);

        const keys = Object.keys(rootState);

        for (let index = 0; index < keys.length; index++) {
            Vue.set(rootState, keys[index], initialModules[keys[index]].state);

            const keysModule = Object.keys(rootState[keys[index]]);

            for (let jindex = 0; jindex < keysModule.length; jindex++) {
                //Vue.set(rootState, keys[index], initialModules[keys[index]].state);
                //rootState[keys[index]][keysModule[jindex]] = initialModules[keys[index]].state[keysModule[jindex]];
            }
        }

        return;
        */
        var role = localStorage.getItem('role');

        axios.post(role+'/logout')
        .then(function (response) {
            dispatch('notification/notification', response, {root: true})

            //this.
            commit('LOGOUT');
            // dispatch('settings/resetState', null, {root: true})
        })
    },
    async checkResetPassword({ commit, dispatch }, data) {
        
        try {
            const request = await axios.post('/account/reset-password/check-secret', data);
            dispatch('notification/notification', request, { root: true })
        } catch (error) {
            dispatch('notification/notification', error.response, { root: true })
        }
    },
    async sendResetPassword({ commit, dispatch }, data) {
        try {
            const request = await axios.post('/account/forgot-password', data);
            dispatch('notification/notification', request, { root: true })
        } catch (error) {
            dispatch('notification/notification', error.response, { root: true })
        }
    },
    async resetPassword({ commit, dispatch }, data) {
        try {
            const request = await axios.post('/account/reset-password', data);
            if(request.status == 200)
                commit('RESET_PASSWORD', request)
            dispatch('notification/notification', request, {root: true})
        } catch (error) {
            dispatch('notification/notification', error.response, {root: true})
        }
    },
    user({ commit, dispatch }) {
        axios.get('/'+localStorage.getItem('role')+'/me')
        .then(function (response) {
            if(response.status == 200) {
                commit('USER', response);
                dispatch('settings/settings', response, {root: true})
            }
        })
        .catch(function (error) {
            dispatch('notification/notification', error.response, {root: true})
        });
    },
    update({ commit }, data) {
        commit('UPDATE', data);
    },
    updateBalance({ commit }, data) {
        commit('UPDATE_BALANCE', data);
    },
    updateServices({ commit }, data) {
        commit('UPDATE_SERVICES', data);
    },
}
